import Styles from "./Spotify.module.scss";
import BaseNativeAppContainer from '../base-native-app-container/BaseNativeAppContainer'
import LeftPanelMenu from "../left-panel-menu/LeftPanelMenu";
import { useEffect, useState } from "react";

import { ReactComponent as SpotifyIcon } from "../../icons/extra_icons/spotify_icon.svg"
import { ReactComponent as HomeIcon } from "../../icons/extra_icons/home.svg"
import { ReactComponent as SearchIcon } from "../../icons/extra_icons/search.svg"
import { ReactComponent as SpotifyAddIcon } from "../../icons/extra_icons/spotify_add.svg"
import { ReactComponent as LibraryIcon } from "../../icons/extra_icons/spotify_library.svg"

import SearchScreen from "./search/SearchScreen";
import CreatePlaylist from "./create-playlist/CreatePlaylist";
import { APP_KEY_IDS } from "../../constants/constants";
import { getCurrentOption } from "../../global/functions/functrions";

const Spotify = () => {

  const leftMenuItem = [
    {
      options: [
        {
          id: "0",
          label: "Home",
          icon: <HomeIcon />
        },
        {
          id: "1",
          label: "Browse",
          icon: <SearchIcon />
        },
        {
          id: "2",
          label: "Create Playlist",
          icon: <SpotifyAddIcon />
        },
      ]
    },
  ]

  const libraryOptions = [
    {
      id:"3",
      label: "Your Library",
      icon: <LibraryIcon />,
      options: []
    },
  ]


  const playlists = [
    {
      options: [
        {
          id: "4",
          label: "Top Indian Hits",
          link: "https://open.spotify.com/embed/playlist/37i9dQZEVXbMWDif5SCBJq?utm_source=generator"
        },
        {
          id: "5",
          label: "Top Global",
          link: "https://open.spotify.com/embed/playlist/37i9dQZEVXbMDoHDwVN2tF?utm_source=generator"
        },
        {
          id: "6",
          label: "Top Indian",
          link: "https://open.spotify.com/embed/playlist/37i9dQZEVXbLZ52XmnySJg?utm_source=generator"
        },
        {
          id: "7",
          label: "Viral",
          link: "https://open.spotify.com/embed/playlist/37i9dQZEVXbLiRSasKsNU9?utm_source=generator"
        },
        {
          id: "8",
          label: "My Playlist",
          link: "https://open.spotify.com/embed/playlist/5TOGeO4uRSnxGasvJDy7iG?utm_source=generator&theme=0"
        },
        {
          id: "9",
          label: "Audiobooks",
          link: "https://open.spotify.com/embed/show/6R76Hw6GPIX8AnFXE9UtWf?utm_source=generator&theme=0&t=0"
        },
        {
          id: "10",
          label: "Funny",
          link: "https://open.spotify.com/embed/playlist/5NF6YWCUxyZlZO96A3PHym?utm_source=generator"
        },
        {
          id: "11",
          label: "Ted Talks",
          link: "https://open.spotify.com/embed/playlist/6VouoU8EkWdkxoyfWKXOE7?utm_source=generator"
        },
      ]
    },
  ]

  const [activeOption, setActiveOption] = useState("0")
  const [activeLink, setActiveLink] = useState("")

  const onSuccessfulSubmission = (option:any) => {
    setActiveLink(option.link)
  }

  const getMainScreen = () => {
    switch (getCurrentOption(activeOption)) {
      case "0": return <div className={Styles.home_container}>Check library</div>
      case "1": return <SearchScreen />
      case "2": return <CreatePlaylist />
      default:
        return <iframe className={Styles.frame} src={activeLink} frameBorder="0" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"></iframe>
    }
  }


  return (
    <BaseNativeAppContainer 
      title={"Spotify"}
      appId={APP_KEY_IDS.SPOTIFY}
      loadFromX={30}
      width={900}
      height={600}
      MainScreen={
        <div className={Styles.container}>
          <div className={Styles.sidebar}>
            <div className={Styles.spotify_logo}>
              <div className={Styles.icon}>
                <SpotifyIcon width={30} height={30} />
              </div>
              <div className={Styles.label}>
                Spotify
              </div>
            </div>
            <LeftPanelMenu specialTheme={"spotify"} menuContent={leftMenuItem} activeValue={activeOption} handleOptionClick={setActiveOption} />
            <div style={{ marginTop: "6px" }}>
              <LeftPanelMenu specialTheme={"spotify"} menuContent={libraryOptions} activeValue={activeOption} handleOptionClick={setActiveOption} />
            </div>
            <div className={Styles.title}>
              Playlists
            </div>
            <div className={Styles.playlist_container}>
              <LeftPanelMenu specialTheme={"spotify"} menuContent={playlists} activeValue={activeOption} handleOptionClick={setActiveOption} onSuccessfulSubmission={onSuccessfulSubmission} />
            </div>
          </div>
          <div className={Styles.main}>
            {getMainScreen()}
          </div>
        </div>
      } />
  )
}

export default Spotify
